<template>
  <div>
    <v-flex>
      <v-layout wrap justify-space-between>
        <v-flex mr-md-0 align-self-baseline>
          <h3 class="font-weight-medium display-30">
            {{ t('titles.candidates.customJobsTitle') }} ({{ numOfJobs }})
          </h3>
        </v-flex>

        <v-flex text-left mt-1 align-self-baseline>
          <nuxt-link
            :to="smartLink"
            :class="!$vuetify.breakpoint.mdAndUp ? 'no-underline' : ''"
          >
            <span class="display-18" v-show="$vuetify.breakpoint.mdAndUp">
              הגדרות הסוכן החכם
            </span>

            <span
              class="no-underline cogout"
              v-show="!$vuetify.breakpoint.mdAndUp"
            >
              <v-icon
                color="white "
                small
                class="no-underline icon-shape-1w"
              ></v-icon>
            </span>
          </nuxt-link>
        </v-flex>
      </v-layout>
      <v-row class="mt-2" v-if="userActive">
        <v-col cols="12">
          <h3 class="font-weight-medium display-24">
            {{ t('titles.candidates.displayAgents') }}
          </h3>
        </v-col>
        <v-col class="agents-slider">
          <v-slide-group
            show-arrows
            v-model="toggleAgentsModel"
            @change="toggleAgenst()"
            center-active
            :value="toggleAgentsModel"
          >
            <v-slide-item
              v-for="(n, index) in ActiveAgents"
              :key="n.AgentCode"
              v-slot="{ active, toggle }"
              :value="parseInt(n.AgentCode)"
            >
              <v-btn
                class="mx-2 agent-btn display-18"
                :class="[loading ? 'disabledLink' : '', `agent-btn-${index}`]"
                :input-value="active"
                active-class="primary white--text disabledLink"
                depressed
                rounded
                @click="toggle"
              >
                {{ n.AgentName.slice(0, 20) + '...' }}
              </v-btn>
            </v-slide-item>
          </v-slide-group>
        </v-col>
      </v-row>
    </v-flex>

    <v-list
      v-for="(item, i) in items"
      :key="item.Code"
      class="jobList_vacancy"
      :class="[removeDislikedJob(item.Code) ? 'py-0' : null]"
    >
      <JobItem
        :job-details="item"
        :job-index="i"
        class="job-item pt-0 mt-4"
        :is-single-job="false"
        :showRank="showRank"
        v-show="!removeDislikedJob(item.Code)"
        :ssasource="2"
        :recomended-job="item.JobInfo.IsRecommender"
      />
      <v-layout v-if="i === 3" mt-7 text-center pa-0>
        <v-flex class="inner_banner">
          <client-only>
            <GptAd
              class="resultsBanner_jobs"
              :ad-unit="dfpToShow.dfpID"
              :is-responsive="true"
              :size="dfpToShow.dfpSize"
            />
          </client-only>
        </v-flex>
      </v-layout>
    </v-list>

    <v-layout v-show="emptyMsg" column justify-center text-center>
      <v-flex v-if="!userActive" mt-4>
        <h4 class="display-22">
          <span class="black--text">
            כיף שבאת! הגעת לאזור האישי....הרשם עכשיו
          </span>
          <!-- <span v-html="t('titles.candidates.myBoardEmtyTitleNotRegistered')" /> -->
          <nuxt-link :to="smartLink" class="display-22">
            והסוכנת החכמה תעבוד בשבילך
          </nuxt-link>
        </h4>
      </v-flex>
    </v-layout>

    <v-row v-show="displayRecommender && !isLoading">
      <v-col class="d-flex flex-column">
        <h4
          class="display-32 mt-8 mb-0 primary--text font-weight-medium"
          v-text="t('jobs.additionalJobs')"
        />
        <p
          class="display-16 font-weight-medium mb-1"
          v-text="t('jobs.additionalJobsSun')"
        ></p>
      </v-col>
    </v-row>
    <v-row
      v-show="displayRecommender && !isLoading"
      justify="center"
      class="mt-2"
    >
      <v-col cols="12">
        <Recommender
          :currentPage="'recommender_Personal Area'"
          :maxJobs="15"
          :forwardToJobPage="false"
          :displayType="2"
          :displayJobDescription="true"
          :headerDisplay="false"
        />
        <!-- spacer for Odd num of jobs  -->
      </v-col>
    </v-row>
    <CvConfirmation />
  </div>
</template>
<script>
import JobItem from '@/components/Jobs_List/Jobs_On_Drushim/Job_Item/JobItem';
import CurrentUser from '@/components/mixins/CurrentUser';
import CvConfirmation from '@/components/Dialogs/CvConfirmation/CvConfirmation';
import Recommender from '@/components/Recommender/Recommender';

export default {
  mixins: [CurrentUser],
  components: {
    JobItem,
    CvConfirmation,
    Recommender,
  },

  props: {
    numOfJobs: {
      type: Number,
      required: false,
      default: () => '-',
    },

    items: {
      type: Array,
    },

    emptyMsg: {
      type: Boolean,
    },

    loading: {
      type: Boolean,
      required: false,
      default: false,
    },

    userActive: {
      type: Boolean,
    },
    showRank: {
      type: Boolean,
      required: false,
      default: false,
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    activeAgentsUrl: {
      type: Number,
      required: false,
      default: () => 0,
    },
  },

  data() {
    return {
      generalDFP: {
        dfpID: '3177829/personalarea_baner_desktop',
        dfpSize: [925, 100],
        id: '1588421797276-0',
      },
      mobileDFP: {
        dfpID: '3177829/search_results_mob',
        dfpSize: [320, 50],
        id: '1585638687340-0',
      },
      dislikedJobs: [],
      toggleAgentsModel: this.activeAgentsUrl,
    };
  },

  computed: {
    displayRecommender() {
      return this.items.length < 10;
    },
    noJobBasket(jobCode) {
      return this.NoJobBasket.includes(jobCode);
    },
    dfpToShow() {
      return this.$vuetify.breakpoint.smAndUp
        ? this.generalDFP
        : this.mobileDFP;
    },
    smartLink() {
      if (this.CurrentUser && this.SmartAgentActive) {
        return '/personal/smartalertsnotification/';
      } else {
        return '/smartalerts.aspx';
      }
    },
  },

  mounted() {
    this.toggleAgentsModel = this.activeAgentsUrl;
  },

  async fetch() {
    await this.$auth.fetchUser();
  },

  methods: {
    removeDislikedJob(jobCode) {
      return this.NoJobBasket.includes(jobCode);
    },
    toggleAgenst() {
      if (!this.loading) {
        const agentsQuery = this.toggleAgentsModel.toString();
        this.$router.push(`?agentscodes=${agentsQuery}`);
      }
    },
  },

  beforeDestroy() {
    this.$nuxt.$off('removeJob');
  },
};
</script>

<style lang="scss" scoped>
.job-item {
  position: relative;
  border-right: 9px solid #f2f0ef;

}

.job-item.preferred {
  border-right: 9px solid $primary;
}

.job-item.preferred.job-submitted {
  border-right: 9px solid $lightGreen;
}

.job-item.preferred {
  border-right: 9px solid $primary;
}

.job-item.preferred.job-submitted {
  border-right: 9px solid $lightGreen;
  background-color: $bgGrayJob;
}

.job-item.detailsIsOpen {
  background-color: #f6f7f9;
}

.job-item.job-submitted {
  border-right: 9px solid $lightGreen;
  background-color: $bgGrayJob;
}

.job-item.job-submitted:after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: -1;
  background-color: $bgGrayJob;
}

.job-item.job-submitted.detailsIsOpen:after {
  display: none;
}

.cogout {
  display: inline-flex;
  background: $primary;
  padding: 3px;
  border-radius: 100%;
  height: 33px;
  width: 33px;
  text-align: center;
  justify-content: center;
}
.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #ffffff;
  color: #ff7100;
  border: 1px solid #f0f0f0;
}
</style>
